<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
    text: String,
    bold: Boolean,
    clazz: String,
    // Add this to toggle the "ink link" behavior
    clickable: {
        type: Boolean,
        default: false
    },
    icon: String,
    iconColor: String,
})

const emit = defineEmits(['press']);

function press() {
    if (props.clickable) {
        emit('press');
    }
}
</script>

<template>
    <component
        :is="bold ? 'strong' : 'span'"
        :class="[clazz, { 'ink-link': clickable }]"
        style="white-space: nowrap;"
        @click="press"
    >
        {{ text }}
        <v-icon :color="iconColor" v-if="icon">{{ icon }}</v-icon>
    </component>
</template>

<style scoped>
/* Base ink style for all instances */
.ink-link {
    cursor: pointer;
    position: relative;
    transition: color 0.3s ease;
    color: #2c2e30;
}

/* Underline only appears for clickable components */
.ink-link::after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 1.2px;
    background-color: currentColor;
    opacity: 0.4;
    /* Hand-drawn look */
    border-radius: 40% 60% 30% 70% / 50%;
    transition: opacity 0.3s, transform 0.3s;
}

/* Hover effects only for clickable components */
.ink-link:hover {
    color: #000;
    text-shadow: 0.5px 0.5px 1px rgba(0,0,0,0.2);
}

.ink-link:hover::after {
    opacity: 0.8;
    transform: scaleX(1.05);
}
</style>